import React from "react";
import APIClient from "../APIClient";

export default function (): APIClient {
    return React.useMemo(() => new APIClient(), []);
}
